/* THV: auto-add the free mystery earrings at $250+ (retail only), remove below. */
(function () {
  var GIFT = 67874419146978, GOAL = 25000, busy = false;
  function refresh() {
    var drawer = document.querySelector('cart-drawer');
    var onCartPage = !!document.getElementById('main-cart-items');
    if (onCartPage) { window.location.reload(); return; }
    fetch('/?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
      var p = new DOMParser();
      if (drawer && s['cart-drawer']) {
        var n = p.parseFromString(s['cart-drawer'], 'text/html').querySelector('.drawer__inner');
        var o = drawer.querySelector('.drawer__inner');
        if (n && o) o.innerHTML = n.innerHTML;
        drawer.classList.toggle('is-empty', !!(n && n.querySelector('.drawer__inner-empty')));
      }
      var b = document.getElementById('cart-icon-bubble');
      if (b && s['cart-icon-bubble']) {
        var nb = p.parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (nb) b.innerHTML = nb.innerHTML;
      }
    }).catch(function () {});
  }
  function check() {
    if (busy) return; busy = true;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var sub = 0, gift = null;
      cart.items.forEach(function (i) { if (i.variant_id === GIFT) gift = i; else sub += i.original_line_price; });
      var req = null;
      if (sub >= GOAL && !gift) {
        req = fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: GIFT, quantity: 1 }] }) });
      } else if (gift && (sub < GOAL || gift.quantity > 1)) {
        req = fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: gift.key, quantity: sub < GOAL ? 0 : 1 }) });
      }
      if (!req) { busy = false; return; }
      return req.then(function () { busy = false; refresh(); });
    }).catch(function () { busy = false; });
  }
  document.addEventListener('DOMContentLoaded', function () {
    check();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(check, 300); });
    }
  });
})();
